import { IconProps } from "./types";

export default function IcoVehicleCar({
	color = "#9CA3AF",
	width = "22.5",
	height = "18"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 19"
			fill="none"
		>
			<g clipPath="url(#clip0_639_971)">
				<path
					d="M3 3.90625V7H6.375V3.625H3.28125C3.12656 3.625 3 3.75156 3 3.90625ZM19.9453 7L17.1012 3.625H14.25V7H19.9453ZM12 7V3.625H8.625V7H12ZM21.5625 13.75H21C21 15.6133 19.4883 17.125 17.625 17.125C15.7617 17.125 14.25 15.6133 14.25 13.75H9.75C9.75 15.6133 8.23828 17.125 6.375 17.125C4.51172 17.125 3 15.6133 3 13.75H2.4375C1.50586 13.75 0.75 12.9941 0.75 12.0625V3.90625C0.75 2.50703 1.88203 1.375 3.28125 1.375H7.5H13.125H17.1012C17.7656 1.375 18.3949 1.6668 18.8238 2.17656L22.7227 6.80664C23.0637 7.21094 23.25 7.72422 23.25 8.25508V12.0625C23.25 12.9941 22.4941 13.75 21.5625 13.75ZM19.3125 13.75C19.3125 13.3024 19.1347 12.8732 18.8182 12.5568C18.5018 12.2403 18.0726 12.0625 17.625 12.0625C17.1774 12.0625 16.7482 12.2403 16.4318 12.5568C16.1153 12.8732 15.9375 13.3024 15.9375 13.75C15.9375 14.1976 16.1153 14.6268 16.4318 14.9432C16.7482 15.2597 17.1774 15.4375 17.625 15.4375C18.0726 15.4375 18.5018 15.2597 18.8182 14.9432C19.1347 14.6268 19.3125 14.1976 19.3125 13.75ZM6.375 15.4375C6.82255 15.4375 7.25178 15.2597 7.56824 14.9432C7.88471 14.6268 8.0625 14.1976 8.0625 13.75C8.0625 13.3024 7.88471 12.8732 7.56824 12.5568C7.25178 12.2403 6.82255 12.0625 6.375 12.0625C5.92745 12.0625 5.49823 12.2403 5.18176 12.5568C4.86529 12.8732 4.6875 13.3024 4.6875 13.75C4.6875 14.1976 4.86529 14.6268 5.18176 14.9432C5.49823 15.2597 5.92745 15.4375 6.375 15.4375Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_639_971">
					<path d="M0.75 0.25H23.25V18.25H0.75V0.25Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
